<div id="job-row-item" [ngClass]="(isDesktop$ | async) ? 'desktop-version' : 'small-version'">
    <app-dot-status [status]="job.status"></app-dot-status>
    <div id="job-row" (click)="onClick.emit(job)">

        @if(job.status === 'COMPLETED'){
            <div class="completed-gradient"></div>
        }

        <div id="thumbnail">
            <img [src]="job.thumbnail || 'https://i.imgur.com/UEmDZb9t.jpg'">
            <span>{{job.duration ?? 0 | timer:job.duration ?? 0 }}</span>
        </div>

        <div id="job-data">
            <p id="job-row-data-title">{{job.title}} <span>#{{job.id}}</span> </p>
            <p id="job-row-data-updated-at">Mis à jour: {{job.updatedAt}}</p>
            <div id="job-row-data-progress">
                <div id="progress" [ngClass]="job.status.toLowerCase()"
                    [ngStyle]="{width : job.completedPercent + '%'}"></div>
            </div>
            <p id="current-task">

                @switch (job.currentTask.type) {
                @case ('UPLOAD') {Envoi de la vidéo}
                @case ('PROCESSING') {Pré-traitement}
                @case ('TRANSCRIPTION') {Transcription de l'audio}
                @case ('TRANSLATION') {Traduction du texte}
                @case ('SUBTITLE_GENERATION') {Génération des sous-titres}
                @case ('VOICES_GENERATIONS') {Génération de la voix}
                @case ('VIDEO_EDITING') {Montage de la vidéo}
                @default {default}
                } {{' '}}
                @switch (job.currentTask.status) {
                @case ('IN_PROGRESS') {En cours}
                @case ('COMPLETED') {Terminé}
                @case ('ERROR') {Erreur}
                @case ('WAITING_RESPONSE') {En attente de réponse}
                @default {En attente}
                }
            </p>
        </div>
        <div class="vertical-divider"></div>
        @if(job.LangFrom && job.LangTo){
        <div id="laguages">
            <p>{{job.LangFrom.short | uppercase }}</p>
            <lucide-angular name="arrowRight"></lucide-angular>
            <p>{{job.LangTo.short | uppercase }}</p>
        </div>
        }
        <div class="vertical-divider"></div>

        <div id="menu-button">
            <lucide-angular name="ellipsis-vertical"></lucide-angular>
        </div>
    </div>
</div>